module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tab-content sort-type",
    attrs: {
      "id": "app-stat-list-template"
    }
  }, [_c('div', {
    staticClass: "job-list-container"
  }, [(_vm.list.length === 0) ? _c('div', [_c('div', {
    staticClass: "no-data"
  }, [_vm._v(_vm._s(_vm.infoText))])]) : _c('div', [_c('ul', {
    staticClass: "job-card-grid new-type"
  }, _vm._l((_vm.list), function(result) {
    return _c('li', {
      key: result.APP_NO,
      staticClass: "job-card"
    }, [_c('a', {
      attrs: {
        "href": "javascript:void(0)",
        "title": "가치동행일자리 {{ result.BIZ_CD_NM }} {{ result.BIZ_CD_NM }} {{ result.BIZ_CD_NM }} {{"
      }
    }, [_c('div', {
      staticClass: "card-header flex-justify-between"
    }, [(_vm.annKindType === 'JB') ? _c('span', {
      staticClass: "job-tag type2"
    }, [_vm._v("가치동행일자리")]) : (result.BIZ_SE === 'IN49001') ? _c('span', {
      staticClass: "job-tag type1"
    }, [_vm._v(_vm._s(result.BIZ_CD_NM))]) : (result.BIZ_SE === 'IN49003') ? _c('span', {
      staticClass: "job-tag type2"
    }, [_vm._v(_vm._s(result.BIZ_CD_NM))]) : (result.BIZ_SE === 'IN49006') ? _c('span', {
      staticClass: "job-tag type3"
    }, [_vm._v(_vm._s(result.BIZ_CD_NM))]) : (result.BIZ_SE === 'IN49007') ? _c('span', {
      staticClass: "job-tag type4"
    }, [_vm._v(_vm._s(result.BIZ_CD_NM))]) : (result.BIZ_SE === 'IN49008') ? _c('span', {
      staticClass: "job-tag type5"
    }, [_vm._v(_vm._s(result.BIZ_CD_NM))]) : (result.BIZ_SE === 'IN49009') ? _c('span', {
      staticClass: "job-tag type1"
    }, [_vm._v(_vm._s(result.BIZ_CD_NM))]) : (result.BIZ_SE === 'IN49004') ? _c('span', {
      staticClass: "job-tag type2"
    }, [_vm._v("기타")]) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "status-badge",
      class: result.classColor
    }, [_vm._v(_vm._s(result.codeLabel))])]), _vm._v(" "), _c('div', {
      staticClass: "card-body"
    }, [(result.CORPR_ORG !== null) ? _c('span', {
      staticClass: "sub-title"
    }, [_vm._v(_vm._s(result.CORPR_ORG))]) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "title-line"
    }, [_vm._v(_vm._s(_vm._f("decodeHtml")(result.ANN_NM)))]), _vm._v(" "), _c('div', [_c('span', {
      staticClass: "label-status"
    }, [_vm._v(_vm._s(result.ANN_RCRT_STAT_NM))])]), _vm._v(" "), _c('dl', {
      staticClass: "recruitment-info"
    }, [_c('dt', [_vm._v("모집기간 :")]), _vm._v(" "), _c('dd', [_vm._v(_vm._s(result.APPDURNG_ST) + "~" + _vm._s(result.APPDURNG_ED))]), _vm._v(" "), (result.BIZ_YEAR !== '' && result.BIZ_YEAR !== null) ? [_c('dt', [_vm._v("사업년도 :")]), _vm._v(" "), _c('dd', [_vm._v(_vm._s(result.BIZ_YEAR))])] : _vm._e(), _vm._v(" "), (result.OPER_ORG_NM !== '' && result.OPER_ORG_NM !== null) ? [_c('dt', [_vm._v("운영기관 :")]), _vm._v(" "), _c('dd', {
      staticClass: "multiline-ellipsis"
    }, [_vm._v(_vm._s(result.OPER_ORG_NM))])] : _vm._e()], 2), _vm._v(" "), _c('div', {
      staticClass: "button-area mypage-type1 mt-0"
    }, [_c('button', {
      staticClass: "btn btn-secondary btn-md appView",
      on: {
        "click": function($event) {
          return _vm.showAppViewModal(result.APP_NO, result.ANN_NO)
        }
      }
    }, [_vm._v("신청 정보 보기")]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-primary btn-md",
      on: {
        "click": function($event) {
          return _vm.showAnnDetailModal(result.APP_NO, result.ANN_NO)
        }
      }
    }, [_vm._v("공고 상세 보기")])])])])])
  }), 0)]), _vm._v(" "), _c('pagination', {
    attrs: {
      "totalPages": _vm.paginationInfo.totalPageCount,
      "currentPage": _vm.paginationInfo.currentPageNo,
      "size": _vm.paginationInfo.pageSize
    },
    on: {
      "update:currentPage": [function($event) {
        return _vm.$set(_vm.paginationInfo, "currentPageNo", $event)
      }, _vm.handlePageChange],
      "update:current-page": function($event) {
        return _vm.$set(_vm.paginationInfo, "currentPageNo", $event)
      }
    }
  }), _vm._v(" "), _c('app-view-modal', {
    attrs: {
      "appViewModal": _vm.appViewModal,
      "annKindType": _vm.annKindType,
      "appNo": _vm.seletedAppNo,
      "annNo": _vm.seletedAnnNo,
      "bizSe": _vm.seletedBizSe
    },
    on: {
      "update:appViewModal": function($event) {
        _vm.appViewModal = $event
      },
      "appAdditionEdit": _vm.appAdditionEdit
    }
  }), _vm._v(" "), _c('company-app-view-modal', {
    attrs: {
      "companyAppViewModal": _vm.companyAppViewModal,
      "annKindType": _vm.annKindType,
      "appNo": _vm.seletedAppNo,
      "annNo": _vm.seletedAnnNo
    },
    on: {
      "update:companyAppViewModal": function($event) {
        _vm.companyAppViewModal = $event
      }
    }
  }), _vm._v(" "), _c('ann-detail-modal', {
    attrs: {
      "annDetailModal": _vm.annDetailModal,
      "annKindType": _vm.annKindType,
      "appNo": _vm.seletedAppNo,
      "annNo": _vm.seletedAnnNo
    },
    on: {
      "update:annDetailModal": function($event) {
        _vm.annDetailModal = $event
      }
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fb6ce24a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/main/member/APP/AppStatList.vue
// module id = 1539
// module chunks = 6